import Header from "./Header/Header";
import PreviewingVideo from "./PreviewingVideo/PreviewingVideo";
import VideoConfig from "./VideoConfig/VideoConfig";
import VideoGroup from "./VideoGroup/VideoGroup";
import useCoverAndBg from "@/useStore/mixCutDetail/useCoverAndBg";
import React, {
  Profiler,
  createContext,
  useEffect,
  useRef,
  useState,
  useContext,
} from "react";
import { observer } from "mobx-react";
import { useNavigate, useParams } from "react-router-dom";
import useVideoGroup from "@/useStore/mixCutDetail/useVideoGroup";
import useMixCutDetail from "@/useStore/mixCutDetail/useMixCutDetail";
import {
  toIdGetEngineer,
  toIdGetEngineerContent,
} from "@/services/createSpace/engineering";
import useMixCutDetailInit from "@/useStore/mixCutDetail/useMixCutDetailInit";
import VideoGlobalModal from "./TipModal/VideoGlobalModal";
import mixCutDetailCheck from "@/useStore/mixCutDetail/mixCutDetailCheck";
import moment from "moment";
import { toIdGetCustomScript } from "@/services/createSpace/script";
import useParseScript, {
  getCaption,
} from "@/useStore/mixCutDetail/useParseScript";
import usePreviewConfig from "@/useStore/preview/usePreview";
import useJsonToRenderObj from "@/useStore/mixCutDetail/useJsonToRenderObj";
import usePreviewInfo from "@/useStore/mixCutDetail/usePreviewInfo";
import { Button, Message, Modal } from "@arco-design/web-react";
import useMixCutDetailSave from "@/useStore/mixCutDetail/useMixCutDetailSave";
import TextAnalysis from "./Components/TextAnalysis";
import SensitiveListDrawer from "./Components/SensitiveListDrawer";
import { useSearchParams } from 'react-router-dom';
import "./MixCutDetail.less";
import LoadingGIF from "@/components/UI/LoadingGIF";
import {
  bindingVideo,
  getBindVideoMaterial,
  getBindVideoMaterialStatus,
  getSensitiveWord,
} from "@/services/mixCutDetail/mixCutDetail";
import mixCutDetailStore from "@/stores/mixCutDetailStore";
import VoLongButton from "@/components/VLButton/VLButton";
import useCaption from "@/useStore/mixCutDetail/useCaption";
import { debounce } from "lodash";
import {
  initCaptionItem,
  toIndexGetInitTitleTextSetting,
} from "@/stores/mixCutDetailStore/init";
import ConfigStore from "@/stores/mixedConfig/index";
import { getSpeech } from "@/services/createSpace/material";
import { checkLanguage } from "@/utils/judgment";
import useGlobalCaption from "@/useStore/mixCutDetail/useGlobalCaption";
import { ICaption } from "@/stores/mixCutDetailStore/type/caption";
import MixedConfig from "@/stores/mixedConfig";
import useNavigateTo from "@/utils/useNavigateTo";

export interface IMixCutDetailContext {
  videoGroupActive: number;
  videoGroupTransitionId: string;
  setVideoGroupActive: React.Dispatch<React.SetStateAction<number>>;
}

export const mixCutDetailContext = createContext<IMixCutDetailContext>(null);

type ActiveType = "transition" | "title" | "caption";
const MixCutDetail = observer(() => {
  const [search] = useSearchParams();
  const { navigateTo } = useNavigateTo();
  const { id, script_id, keywords } = useParams();
  const { parseCutsomScript } = useParseScript();
  const { maxCount } = usePreviewInfo();
  const regExp = new RegExp(/[,，.。;；:：?？!！………—、-]/, "g");
  const { handleDecorationChange } = useCoverAndBg();
  const {
    projectCaption,
    projectSences,
    setProjectSences,
    handleProjectName,
    handleProjectSencesAdd,
    handleProjectSencesDelete,
    handleProjectVideoChange,
    handleChangeVideoItemStartAndDuration,
  } = useVideoGroup();
  useEffect(() => {
    console.log(projectCaption, 'projectCaption')
  }, [projectCaption]);
  const { quickSaveMixCutDetail } = useMixCutDetailSave();
  const { handleToChangeVideoIndexSetTitleAndCaption } = usePreviewConfig();
  const { global, projectMsg, handleProjectMsgSet, toggleGlobaltoItem } =
    useMixCutDetail();
  const { handletoOriginJsonRender } = useJsonToRenderObj();
  const { initAllMixCutDetal } = useMixCutDetailInit();
  const [videoConfigActiveIndex, setVideoConfigActiveIndex] = useState(0);
  const [videoGroupActive, setVideoGroupActive] = useState(0);
  const [videoGroupTransitionId, setVideoGroupTransitionId] =
    useState<string>("0");
  const {
    checkJson,
    confirmCaptionsErrorIsEmpty,
    confirmSencesErrorIsEmpty,
    // combSenceMaterials,
  } = mixCutDetailCheck();
  const [tipItemModalVisible, setTipItemModalVisible] = useState(false);
  const [editorActiveIndex, setEditorActiveIndex] = useState<{
    groupIndex: number;
    activeIndex: number;
    type: ActiveType;
  }>({
    groupIndex: null,
    activeIndex: null,
    type: "" as "title",
  });
  const [textVisible, setTextVisible] = useState(false);
  const [senVisible, setSenVisible] = useState(false);
  const [textContent, setTextContent] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [showAnalysis, setShowAnalysis] = useState(false);
  const [analysisId, setAnalysisId] = useState("");
  const [videoStatusList, setVideoStatusList] = useState([]);
  const [total_words, setTotal_words] = useState(0); // 总字数
  const [total_sensitive, setTotal_sensitive] = useState(0); // 总敏感词
  const [sensitiveList, setSensitiveList] = useState([]);
  const [sensitiveData, setSensitiveData] = useState([]);
  const { handleSaveMixCutDetailSave } = useMixCutDetailSave();
  const [showConfig, setShowConfig] = useState(false);
  const init = async (id: number, script?: number) => {
    try {
      const result = await toIdGetEngineer(id);
      handleProjectMsgSet({
        ...result,
        updated_at: moment
          .unix(result.updated_at)
          .format("YYYY-MM-DD HH:mm") as any,
      });
      if (script) {
        const data = await toIdGetCustomScript(script);
        parseCutsomScript(data);
      } else {
        const contentResult = await toIdGetEngineerContent(id);
        const content = JSON.parse(contentResult);
        if (Object.keys(content || {}).length === 0) {
          initAllMixCutDetal();
        } else {
          handletoOriginJsonRender(content);
          try {
            const videoBindMaterial = await getBindVideoMaterial(id);
            if (
              (videoBindMaterial || []).length === 0 &&
              Object.keys(content?._materials || {}).length > 0
            ) {
              bindingVideo(id, Object.keys(content?._materials || {}) || []);
            }
          } catch (e) {
            console.log(e);
          }
        }
        if (search.get('keywords')) {
          ConfigStore.global_settings.enabled = true;
          ConfigStore.global_settings.keywords = search.get('keywords');
          ConfigStore.global_settings.keywords_id = search.get('keywords_id');
        }
      }
    } catch (e) {
      if (e === "资源不存在") {
        Message.error("工程已被删除！");
        setTimeout(() => {
          window.close();
        }, 3000);
        return;
      }
      Message.error(e);
      console.log(e);
    }
  };

  useEffect(() => {
    getStatusList();
    setTimeout(() => {
      setShowConfig(true)
    }, 0)
  }, []);

  const getStatusList = () => {
    getBindVideoMaterialStatus(id).then((res) => {
      setVideoStatusList(res.items || []);
    });
  };

  const handleTipModalOkBtnClick = () => {
    handleDecorationChange([])
    toggleGlobaltoItem();
    setVideoGroupActive(0);
    setVideoConfigActiveIndex(0);
  };

  useEffect(() => {
    if (videoGroupActive === 0 && videoConfigActiveIndex === 2) {
      setVideoConfigActiveIndex(0);
    }
    handleToChangeVideoIndexSetTitleAndCaption(videoGroupActive);
  }, [videoGroupActive]);
  const onRenderCallback = (id, phase, actualDuration) => {
    // console.log(`Render duration: ${actualDuration}ms`);
  };
  const executeBasedOnScope = async (
    groupIndex: number,
    index: number,
    type: ActiveType
  ) => {
    if (global) {
      setTipItemModalVisible(true);
      setEditorActiveIndex({ groupIndex, activeIndex: index, type });
    } else {
      setVideoConfigActiveIndex(index);
      setVideoGroupActive(groupIndex);

      if (type === "transition") {
        setVideoGroupTransitionId(groupIndex.toString());
      }
    }
  };
  // 确认提取
  const onTextAnalysis = async (data) => {
    setShowAnalysis(true);
    setAnalysisId(data.id);
    getSearchText(data);
  };
  const getSearchText = debounce(async (data) => {
    const res = await getSpeech({
      media_id: data.media_id,
      material_id: data.id,
      session_id: Number(id),
    });
    if (Array.isArray(res?.subVoices)) {
      setTextContent(res.subVoices.map((item) => item.text).join(","));
      setShowAnalysis(false);
      setTextVisible(true);
      getStatusList();
    } else {
      setShowAnalysis(false);
      Message.error("未提取到台词");
      return false;
    }
  }, 1000);
  // 导入台词
  const handleTextAnalysis = () => {
    if (ConfigStore.global_settings.enabled) {
      if (ConfigStore.global_settings.captions.length === 15) {
        Message.error("最多导入台词组15条");
        return false;
      }
    } else if (
      projectCaption[videoGroupActive].map((item) => item._content_json)
        .length === 15
    ) {
      Message.error("最多导入台词组15条");
      return false;
    }
    const textArr = textContent.split(regExp);
    const _content_json = [];
    textArr.forEach((item) => {
      _content_json.push({
        type: "listItem",
        content: [
          {
            type: "paragraph",
            content: [
              {
                type: "text",
                text: item,
              },
            ],
          },
        ],
      });
    });
    if (ConfigStore.global_settings.enabled) {
      const newItem: ICaption = {
        ...initCaptionItem,
        id: Math.floor(Date.now() + Math.random() * 10000),
        content: textArr.map((text) => {
          return `<speak>${text}</speak>`;
        }),
        _preview: textContent.replaceAll(regExp, "\n\n\n\n"),
        _content_json: _content_json,
      };
      const gCaptions = mixCutDetailStore.getProjectGlobalCaptions();
      mixCutDetailStore.setProjectGlobalCaptions([...gCaptions, newItem]);
      ConfigStore.global_settings.captions = [...gCaptions, newItem];
      handleSaveMixCutDetailSave();
    } else {
      const captions = [...mixCutDetailStore.getProjectCaption()];
      captions[videoGroupActive] = [
        ...captions[videoGroupActive],
        {
          ...initCaptionItem,
          id: Math.floor(Date.now() + Math.random() * 10000),
          _content_json: _content_json,
          _preview: textContent.replaceAll(regExp, "\n\n\n\n"),
          content: textArr.map((text) => {
            return `<speak>${text}</speak>`;
          }),
        },
      ];
      mixCutDetailStore.setProjectCaption([...captions]);
      captions.forEach((item, index) => {
        ConfigStore.scenes[index].caption = item;
      });
      handleSaveMixCutDetailSave();
    }
    setTextVisible(false);
  };

  useEffect(() => {
    init(Number(id), Number(script_id));
  }, [id]);

  useEffect(() => {
    getSensitiveWords();
  }, []);
  const getSensitiveWords = async () => {
    const { data } = await getSensitiveWord(Number(id));
    setTotal_words(data?.total_words);
    setTotal_sensitive(data?.total_sensitive);
    setSensitiveList(data?.scenes);
    if (data?.total_sensitive > 0) {
      const result =
        data?.scenes?.length > 0
          ? data.scenes.flatMap(
              (item) =>
                item?.caption_groups?.flatMap(
                  (li) => li?.sensitive_words ?? []
                ) ?? []
            )
          : [];
      setSensitiveData(result);
    }
  };

  // 替换函数
  const replaceSensitiveWords = (captions, replaceArr) => {
    return captions.map((subArray) =>
      subArray.map((caption) => {
        // Replace in `content`
        caption.content = caption.content.map((text) => {
          replaceArr.forEach((replaceItem) => {
            text = text.replace(
              new RegExp(replaceItem.sensitive_words, "g"),
              replaceItem.newWord
            );
          });
          return text;
        });
        console.log(
          JSON.stringify(caption._content_json),
          "caption._content_json"
        );
        caption._content_json =
          caption?._content_json !== null
            ? caption._content_json.map((item) => {
                if (item.content && item.content.length > 0) {
                  item.content = item.content.map((paragraph) => {
                    if (paragraph.content && paragraph.content.length > 0) {
                      paragraph.content = paragraph.content.map((textItem) => {
                        replaceArr.forEach((replaceItem) => {
                          if (textItem.text) {
                            textItem.text = textItem.text.replace(
                              new RegExp(replaceItem.sensitive_words, "g"),
                              replaceItem.newWord
                            );
                          }
                        });
                        return textItem;
                      });
                    }
                    return paragraph;
                  });
                }
                return item;
              })
            : caption?._content_json;

        // Replace in `_preview`
        replaceArr.forEach((replaceItem) => {
          caption._preview = caption._preview.replace(
            new RegExp(replaceItem.sensitive_words, "g"),
            replaceItem.newWord
          );
        });

        return caption;
      })
    );
  };

  // 敏感词修改
  const handleEmitChange = (data, type) => {
    const replaceList = data;
    // 台词修改
    if (type === 0) {
      const captions = ConfigStore.global_settings.enabled
        ? [ConfigStore.global_settings.captions]
        : mixCutDetailStore.getProjectCaption();
      console.log(JSON.stringify(captions), "captions");
      // 遍历 captions 并替换
      const updatedCaptions = replaceSensitiveWords(captions, replaceList);
      if (ConfigStore.global_settings.enabled) {
        ConfigStore.global_settings.captions = updatedCaptions.flat();
        mixCutDetailStore.setProjectGlobalCaptions(updatedCaptions.flat());
        handleSaveMixCutDetailSave();
      } else {
        mixCutDetailStore.setProjectCaption([...updatedCaptions]);
        // updatedCaptions.flat().forEach((item, index) => {
        //   ConfigStore.scenes[index].caption = item;
        // });
        handleSaveMixCutDetailSave();
      }
    } else {
      // 标题修改
      const titles = ConfigStore.global_settings.enabled
        ? ConfigStore.global_settings.titles
        : mixCutDetailStore.getProjectTitle();
      // 遍历 arr 中的每个对象
      titles.forEach((item) => {
        item.content.forEach((contentItem) => {
          // 遍历 replaceList 中的每个替换规则
          replaceList.forEach((replaceItem) => {
            // 使用正则表达式全局替换敏感词
            const regex = new RegExp(replaceItem.sensitive_words, "g");
            contentItem.text = contentItem.text.replace(
              regex,
              replaceItem.newWord
            );

            // 如果 _text 存在，也进行替换
            if (contentItem._text && contentItem._text.length > 0) {
              contentItem._text.forEach((textItem) => {
                textItem.content.forEach((textContent) => {
                  if (textContent.type === "text") {
                    textContent.text = textContent.text.replace(
                      regex,
                      replaceItem.newWord
                    );
                  }
                });
              });
            }
          });
        });
      });
      mixCutDetailStore.setProTitle([...titles]);
      ConfigStore.global_settings.titles = [...titles];
      handleSaveMixCutDetailSave();
    }
  };
  return (
    <Profiler id="App" onRender={onRenderCallback}>
      <mixCutDetailContext.Provider
        value={{
          videoGroupActive,
          setVideoGroupActive,
          videoGroupTransitionId,
        }}
      >
        <div className="mix-cut-detail-wrapper">
          <Header
            updateTime={projectMsg?.updated_at}
            handleResultBtnClick={async () => {
              if (
                projectSences.filter((item) => !item.setting.disabled)
                  .length === 0
              ) {
                Message.error("当前无可用镜头！");
                return;
              }
              if (!maxCount) {
                return Message.warning("当前魔剪配置无法生成视频！");
              }
              // 校验语种是否一致
              const arr = ConfigStore.global_settings.enabled
                ? ConfigStore.global_settings.captions
                : mixCutDetailStore.getProjectCaption().flat(2);
              let hasError = false;
              if (arr && arr.length > 0) {
                arr.some((item) => {
                  // 去除 <speak> 标签
                  const str = item.content
                    .map((contentItem) =>
                      contentItem.replace(/<\/?speak>/g, "")
                    )
                    .join("");
                  if (ConfigStore.global_settings.enabled && !str) {
                    hasError = true; // 设置错误标志
                    return false;
                  }
                  // 检查语言是否匹配
                  if (str && !checkLanguage(item.voice_setting.lang, str)) {
                    hasError = true; // 设置错误标志
                    return true; // 停止循环
                  }
                  return false; // 继续循环
                });
              }
              if (ConfigStore.global_settings.enabled && hasError) {
                Message.error("请输入台词文案");
                return false;
              }

              if (hasError) {
                Message.error("请选择与台词语言一致的配音选项");
                return false;
              }
              setSenVisible(true);
              const { data } = await getSensitiveWord(Number(id));
              const result = data?.scenes
                .map((item) =>
                  item?.caption_groups?.flatMap(
                    (li) => li?.sensitive_words ?? []
                  ) ?? []
                )
                .flat();
              setSensitiveData(result);
              if (data?.total_sensitive > 0) {
                setTimeout(() => {
                  setSenVisible(false);
                  setTotal_words(data?.total_words);
                  setTotal_sensitive(data?.total_sensitive);
                  setSensitiveList(data?.scenes);
                  setIsOpen(true);
                  return false;
                }, 1000);
              } else {
                setSenVisible(false);
                // window.open(
                //   `/video-clip-result/${id}/${mixCutDetailStore.outputCount}`,
                //   "_blank",
                // );
                navigateTo(
                  `/video-clip-result/${id}/${mixCutDetailStore.outputCount}`
                );
                checkJson();
                await quickSaveMixCutDetail();
              }
            }}
            name={projectMsg?.title}
            handleChangeName={(e) => {
              handleProjectName(e);
            }}
          ></Header>
          <div className="mix-cut-detail-container">
            <VideoGroup
              videoStatusList={videoStatusList}
              analysisId={analysisId}
              showAnalysis={showAnalysis}
              handleHeaderItemClick={(id) => {
                const index = projectSences.findIndex((item) => item.id === id);
                setVideoGroupActive(index);
              }}
              handleVideoGroupAdd={() => {
                handleProjectSencesAdd();
              }}
              handleVideoGroupDelete={(index) => {
                handleProjectSencesDelete(index);
              }}
              data={projectSences}
              handleProjectVideoChange={handleProjectVideoChange}
              handleDataChange={(e) => {
                setProjectSences(e);
              }}
              handleCaptionBtnClick={(e) => {
                executeBasedOnScope(e, 0, "caption");
              }}
              handleTitleBtnClick={(e) => {
                executeBasedOnScope(e, 1, "title");
              }}
              handleChangeVideoItemStartAndDuration={
                handleChangeVideoItemStartAndDuration
              }
              // handlePlayerCaption={handlePlayerCaption}
              // handlePlayerCaptionStop={handlePlayerCaptionStop}
              handleTransitionBtnClick={(e) => {
                executeBasedOnScope(e, 2, "transition");
              }}
              onTextAnalysis={(e) => {
                onTextAnalysis(e);
              }}
            ></VideoGroup>
            {
               showConfig && <VideoConfig
                sensitiveData={sensitiveData}
                handleGlobalChange={() => {
                  setVideoConfigActiveIndex(0);
                  setVideoGroupActive(0);
                  handleTipModalOkBtnClick();
                }}
                videoConfigActiveIndex={videoConfigActiveIndex}
                handleVideoConfigActiveIndexChange={setVideoConfigActiveIndex}
                CationConfig={projectCaption}
                global={global}
              ></VideoConfig>
            }
            <PreviewingVideo></PreviewingVideo>
          </div>
          <VideoGlobalModal
            title={"切换局部配置警告"}
            visible={tipItemModalVisible}
            onCancel={() => {
              setTipItemModalVisible(false);
            }}
            onOk={() => {
              setTipItemModalVisible(false);
              handleTipModalOkBtnClick();
            }}
            content={
              "切换到分镜配置模式，全局配置下的台词组，标题组，还有转场信息将全部丢失，是否继续？"
            }
          />
          <TextAnalysis
            handCancel={() => {
              setTextVisible(false);
            }}
            textVisible={textVisible}
            textContent={textContent}
            handleTextAnalysis={() => {
              handleTextAnalysis();
            }}
          />
          <SensitiveListDrawer
            sensitiveList={sensitiveList}
            total_words={total_words}
            total_sensitive={total_sensitive}
            handleCancel={() => {
              setIsOpen(false);
            }}
            isOpen={isOpen}
            emitChange={(data, type) => {
              handleEmitChange(data, type);
            }}
          />
          <Modal
            style={{ width: "276px" }}
            closable={false}
            visible={senVisible}
            footer={null}
            maskClosable={false}
            getPopupContainer={() => {
              return document.body;
            }}
          >
            <div className="loading-box">
              <LoadingGIF />
              <div className="text">敏感词检测中...</div>
            </div>
          </Modal>
        </div>
      </mixCutDetailContext.Provider>
    </Profiler>
  );
});

export default MixCutDetail;
